export enum ActionStatus {
	INITIAL = "initial",
	PENDING = "pending",
	SUCCESS = "success",
	ERROR = "error",
}